export default __webpack_public_path__ + "static/media/project2.ced73567.jpg";